import { logout } from '@/features/auth';
import type { State } from '@/reducers/types';
import { createSlice } from '@reduxjs/toolkit';

interface PpagState {
  ppagData: {
    answer: string;
  } | null;
  isRegenerated?: boolean;
  title?: string;
}

const initialState: PpagState = {
  ppagData: null,
  isRegenerated: undefined,
  title: undefined,
};

const { name, reducer, actions } = createSlice({
  name: 'ppag',
  initialState,
  reducers: {
    setPpagData(state, action) {
      state.ppagData = action.payload;
    },
    setIsRegenerated(state, action) {
      state.isRegenerated = action.payload;
    },
    setTitle(state, action) {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout.fulfilled, () => initialState);
  },
});

const { setPpagData, setIsRegenerated, setTitle } = actions;

export { name, reducer, setIsRegenerated, setPpagData, setTitle };

export const selectPpagData = (state: State) => state[name].ppagData;
export const selectPpagIsRegenerated = (state: State) => state[name].isRegenerated;
export const selectPpagTitle = (state: State) => state[name].title;
